import React, { Component } from "react";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import AndtDEmailBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/EmailBoxWrapper";
import { phoneNumberValidator } from "../validators";

class LogisticsDetail extends Component {
  render() {

    const {formRef, isDisabled, isIndia, isRequired} = this.props;

    return (
      <div className="row form-box">
        <legend className="form-legend">Customer Store/Purchase Detail</legend>

        <div className="col-lg-6 col-md-12">
          <AndtDEmailBoxWrapper
            decorator="logistic_email_id"
            id="Logistic Email ID"
            required={isRequired}
            disabled={isDisabled}
            label="Email ID"
            message="Enter Email ID"
            placeholder="Enter Email ID"
            validators=""
            maxlength={241}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="logistic_phone_number"
            id="Contact Number"
            required={isRequired}
            disabled={isDisabled}
            label="Contact Number"
            message="Enter Contact Number"
            placeholder="Enter Contact Number"
            maxlength={30}
            validators={isIndia ? [{ validator: phoneNumberValidator }] : ""}
            formRef={formRef}
          />
        </div>
      </div>
    );
  }
}

export default LogisticsDetail;
